import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesConstants } from '../shared/common';
import { IsAuthenticatedGuard } from '../shared/guard';
import { AUTHENTICATION_ROUTES } from '../ui/authentication/routes';
import { CONTROL_SETTINGS } from '../ui/feature/control-settings/routes';
import { MANAGE_USERS_ACCOUNTS_ROUTES } from '../ui/feature/manage-users-accounts/routes';
import { REPORTS_ROUTES } from '../ui/feature/reports/routes';
import { SESSIONS_ROUTES } from '../ui/feature/sessions/routes';
import { LayoutWrapperComponent } from '../ui/layout/layout-wrapper/layout-wrapper.component';
import { WhiteLabelDashboardPageComponent } from '../ui/feature/white-labels-dashboard/pages/white-label-dashboard-page/white-label-dashboard-page.component';
import { PROFILE_ROUTES } from '../ui/feature/user-profile/routes';
import { MARKETPLACE_ROUTES } from '../ui/feature/marketplace/routes';
import { PermissionGuard } from '../shared/guard/permission-guard';
import { Permissions } from '../core/common';
import { SEND_MESSAGES_ROUTES } from '../ui/feature/send-message/routes';
import { EXTRACT_REPORTS_ROUTES } from '../ui/feature/extract-reports/routes';
import { NoPermissionComponent } from '../shared/component/no-permission/no-permission.component';
import { ADD_NEW_TEACHER } from '../ui/feature/add-new-teacher/routes';
import { UPLOADS_ROUTES } from '../ui/feature/uploads/routes';
import { HomePageGuard } from '../shared/guard/homepage-guard';
import { DASHBOARD_ROUTES } from '../ui/feature/dashboard/routes';
import { ReportsChartsComponent } from '../ui/feature/dashboard/pages/reports-charts/reports-charts.component';
import { ContactUsMessagesComponent } from '../ui/feature/contact-us-messages/pages/contact-us-page/contact-us-messages.component';
import { MinimalLayoutComponent } from '../ui/layout/minimal-layout/minimal-layout/minimal-layout.component';
import { ThemeErrorPageComponent } from '../shared/component/theme-error-page/theme-error-page.component';
import { ThemeNotExistGuard } from '../shared/guard/theme-not-exist.guard';
import { ThemeExistGuard } from '../shared/guard/theme-exist.guard';
import { FATIHA_REQUESTS_ROUTES } from '../ui/feature/fatiha-requests/routes';

const routes: Routes = [
  { path: '', redirectTo: '/' + RoutesConstants.DASHBOARD_PAGE_URL, pathMatch: 'full' },
  {
    path: '',
    component: LayoutWrapperComponent,
    canActivate: [IsAuthenticatedGuard, ThemeExistGuard],
    children: [
      {
        path: RoutesConstants.DASHBOARD_PAGE_URL,
        component: ReportsChartsComponent,
        canActivate: [HomePageGuard],
        data: {
          breadcrumb: {
            label: 'DASHBOARD',
            icon: 'home',
          },
          permissions: [
            Permissions.HomePage_CALLS_REPORT_CHART,
            Permissions.HomePage_OnLineStudent_Chart,
            Permissions.HomePage_OnLineTeacher_Chart,
          ],
        },
      },
      {
        path: RoutesConstants.DASHBOARD_WL_PAGE_URL,
        component: WhiteLabelDashboardPageComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: {
            label: 'DASHBOARD',
            icon: 'home',
          },
          permissions: [Permissions.Statistics],
        },
      },
      {
        path: RoutesConstants.NO_PERMISSION_PAGE_URL,
        component: NoPermissionComponent,
        data: {
          breadcrumb: {
            label: 'NOT_ALLOWED',
            icon: 'block',
          },
        },
      },
      {
        path: RoutesConstants.CUSTOMER_SUPPOR_REPORT_PAGE_URL,
        component: ContactUsMessagesComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: {
            label: 'NOT_ALLOWED',
            icon: 'block',
          },
          permissions: [Permissions.HomePage_Teacher_Message, Permissions.HomePage_Student_Message],
        },
      },

      ...REPORTS_ROUTES,
      ...MANAGE_USERS_ACCOUNTS_ROUTES,
      ...CONTROL_SETTINGS,
      // ...SESSIONS_ROUTES,
      ...MARKETPLACE_ROUTES,
      ...PROFILE_ROUTES,
      // ...DASHBOARD_ROUTES,
      ...UPLOADS_ROUTES,
      ...SEND_MESSAGES_ROUTES,
      ...EXTRACT_REPORTS_ROUTES,
      ...ADD_NEW_TEACHER,
      ...FATIHA_REQUESTS_ROUTES,
      // ...SEND_INSOLVENT_CODE
    ],
  },
  ...AUTHENTICATION_ROUTES,
  {
    path: '',
    component: MinimalLayoutComponent,
    canActivate: [IsAuthenticatedGuard],
    children: [
      {
        path: RoutesConstants.THEME_ERROR_PAGE_URL,
        canActivate: [ThemeNotExistGuard],
        component: ThemeErrorPageComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: RoutesConstants.DASHBOARD_PAGE_URL,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
